exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-message[data-v-41720aa8] {\n  display: flex;\n  align-items: center;\n}\n.info-message i[data-v-41720aa8] {\n  padding-right: 15px;\n}\n.info-message p[data-v-41720aa8] {\n  flex: 1;\n  margin-bottom: 0;\n}\n", ""]);

// exports
